import { ServerEvent } from "@/common/notification";
import {
	AgentPermissionsState,
	AgentPermissionsActions,
} from "@/common/stores/persistingStores/agentPermissions";
import { useAgentPermissionsStore } from "@/common/stores/persistingStores/agentPermissions/agentPermissionsStore";
import { useAuth } from "@/hooks/authentication";
import { notificationListener } from "@/hooks/notification";
import { fetchAgentPermissions } from "@/repository/queryFns/permissions";
import { useEffect } from "react";

export const useAgentPermissionsManager = () => {
	const authContext = useAuth();
	const updatePermissions = useAgentPermissionsStore(
		(actions: AgentPermissionsActions) => actions.update
	);

	useEffect(() => {
		if (!authContext.isLogged) {
			return;
		}

		fetchAgentPermissions().then(updatePermissions);
	}, [authContext.isLogged]);

	notificationListener(
		ServerEvent.UserPermisionChanged,
		(agentPermissions: AgentPermissionsState) => {
			updatePermissions(agentPermissions);
		}
	);
};
